import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      :host {\n        display: inline-block;\n        font-family: inherit;\n      }\n      :host([disabled]) {\n        opacity: 0.6 !important;\n        cursor: default;\n        pointer-events: none;\n      }\n      :host([disabled]) svg {\n        background: rgba(0, 0, 0, 0.07);\n      }\n\n      #container {\n        display: flex;\n        flex-direction: row;\n        position: relative;\n        user-select: none;\n        min-height: 24px;\n        cursor: pointer;\n      }\n      span {\n        margin-left: 1.5ex;\n        line-height: 24px;\n      }\n      input {\n        opacity: 0;\n      }\n      path {\n        stroke: var(--wired-radio-icon-color, currentColor);\n        stroke-width: var(--wired-radio-default-swidth, 0.7);\n      }\n      g path {\n        stroke-width: 0;\n        fill: var(--wired-radio-icon-color, currentColor);\n      }\n      #container.focused {\n        --wired-radio-default-swidth: 1.5;\n      }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <label id=\"container\" class=\"", "\">\n      <input type=\"checkbox\" .checked=\"", "\" ?disabled=\"", "\" \n        @change=\"", "\"\n        @focus=\"", "\"\n        @blur=\"", "\">\n      <span><slot></slot></span>\n      <div id=\"overlay\"><svg></svg></div>\n    </label>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { WiredBase, BaseCSS, fire } from 'wired-lib/lib/wired-base';
import { customElement, property, css, html, query } from 'lit-element';
import { ellipse, svgNode } from 'wired-lib';

var WiredRadio = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredRadio, _WiredBase);

  var _super = _createSuper(WiredRadio);

  function WiredRadio() {
    var _this;

    _classCallCheck(this, WiredRadio);

    _this = _super.apply(this, arguments);
    _this.checked = false;
    _this.disabled = false;
    _this.focused = false;
    return _this;
  }

  _createClass(WiredRadio, [{
    key: "focus",
    value: function focus() {
      if (this.input) {
        this.input.focus();
      } else {
        _get(_getPrototypeOf(WiredRadio.prototype), "focus", this).call(this);
      }
    }
  }, {
    key: "wiredRender",
    value: function wiredRender() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _get(_getPrototypeOf(WiredRadio.prototype), "wiredRender", this).call(this, force);

      this.refreshCheckVisibility();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return html(_templateObject(), this.focused ? 'focused' : '', this.checked, this.disabled, this.onChange, function () {
        return _this2.focused = true;
      }, function () {
        return _this2.focused = false;
      });
    }
  }, {
    key: "onChange",
    value: function onChange() {
      this.checked = this.input.checked;
      this.refreshCheckVisibility();
      fire(this, 'change', {
        checked: this.checked
      });
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      return [24, 24];
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      ellipse(svg, size[0] / 2, size[1] / 2, size[0], size[1], this.seed);
      this.svgCheck = svgNode('g');
      svg.appendChild(this.svgCheck);
      var iw = Math.max(size[0] * 0.6, 5);
      var ih = Math.max(size[1] * 0.6, 5);
      ellipse(this.svgCheck, size[0] / 2, size[1] / 2, iw, ih, this.seed);
    }
  }, {
    key: "refreshCheckVisibility",
    value: function refreshCheckVisibility() {
      if (this.svgCheck) {
        this.svgCheck.style.display = this.checked ? '' : 'none';
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredRadio;
}(WiredBase);

__decorate([property({
  type: Boolean
}), __metadata("design:type", Object)], WiredRadio.prototype, "checked", void 0);

__decorate([property({
  type: Boolean,
  reflect: true
}), __metadata("design:type", Object)], WiredRadio.prototype, "disabled", void 0);

__decorate([property({
  type: String
}), __metadata("design:type", String)], WiredRadio.prototype, "name", void 0);

__decorate([property(), __metadata("design:type", Object)], WiredRadio.prototype, "focused", void 0);

__decorate([query('input'), __metadata("design:type", HTMLInputElement)], WiredRadio.prototype, "input", void 0);

WiredRadio = __decorate([customElement('wired-radio')], WiredRadio);
export { WiredRadio };